import type { DateValue } from 'react-aria-components';
import { z } from 'zod';

export const reusableNewsletterFormSchema = z.object({
  subscriptionEmail: z.string().trim().email().min(5),
  departureDate: z.custom<DateValue>().nullable().optional(),
  source: z.string()
});

export type ReusableNewsletterFormSchema = z.infer<typeof reusableNewsletterFormSchema>;
